import { Typography } from "@suraasa/placebo-ui"
import Gradient from "assets/gradients/suraasa-gradient.svg"
import clsx from "clsx"

const StepBar = ({
  number,
  text,
  className,
}: {
  number: number
  text: string
  className?: string
}) => {
  return (
    <div className={clsx("relative flex h-7 items-center md:gap-2", className)}>
      <div className="relative flex size-6  items-center justify-center overflow-hidden rounded-full md:!size-6">
        <Typography className="absolute z-10 text-onSurface-100">
          {number}
        </Typography>
        <img src={Gradient} className="absolute z-0" alt="gradient" />
      </div>
      <div className="flex">
        <div className="inline-block !size-1"></div>
        <Typography variant="title2" className="z-10 leading-5">
          {text}
        </Typography>
      </div>
    </div>
  )
}

export default StepBar
